import React from 'react';
import Select from 'react-select';
var KiotSpinner = null;
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Box from '../ui/Box';

import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;

export default class NewWifi extends React.Component {
  constructor(props) {
    super(props);
    let x = new Date();
    this.state = {
      ssid: this.props.details ? this.props.details.ssid : "",
      password: this.props.details ? this.props.details.password : "",
      rooms: this.props.details ? this.props.details.rooms : null,
      room: this.props.details ? this.props.details.rooms[0] : null,

      all_rooms: [],
      spinner: null,
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    };
  }
  componentDidMount() {
    this.getAllRooms();
  }

  getAllRooms() {
    let user = ls.getUserDetails()
    if (user.hotel_id) {
      ds.getAllRooms(user.hotel_id,
        data => {
          if (data && data.length) {
            for (let i of data) {
              i.label = i.hotel_room_id ? i.hotel_room_id.name : '';
              i.value = i.hotel_room_id._id;
            }
          }
          this.setState({
            all_rooms: data,
          })
        }, error => {
          console.log(error);
        })
    }
  }

  handleChanges(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })
  }

  handleChange = (e, index, value) => this.setState({ 'room_num': value });

  createTelephoneNumber(e) {
    e.preventDefault()
    if (this.validated()) {

      this.setState({
        spinner: <KiotSpinner />
      })

      if (this.props.details && this.props.details._id) {
        ds.postEditWifi({
          ssid: this.state.ssid,
          password: this.state.password,
          rooms: this.state.rooms,
          hotel_id: ls.getUserDetails().hotel_id,
          contact_id: this.props.details._id
        }, 
        data => {
          this.props.unMountMe(true);
          this.setState({
            ssid: "",
            password: "",
            rooms: null,
            room: null,
            spinner: null
          });
        }, 
        err => {})

      } else {
        ds.postCreateWifi({
            ssid: this.state.ssid,
            password: this.state.password,
            rooms: this.state.rooms,
            hotel_id: ls.getUserDetails().hotel_id
        }, 
        data => {
          let dialog = {
            open: true,
            head: 'Success',
            body: "Wifi added",
            actions: [
              <FlatButton
                label="Okay"
                primary
                onClick={this.closeDialog.bind(this)}
              />
            ]
          }
          let evt = new CustomEvent('updateWifiTable', { detail: true });
          window.dispatchEvent(evt);
          this.setState({
            ssid: "",
            password: "",
            rooms: null,
            room: null,
            dialog: dialog
          });

        }, err => {
          this.setState({
            spinner: null
          });
        });
      }
    }
  }

  validated() {
    let dialog;
    let flag = true;
    if (!this.state.ssid || !this.state.password || !this.state.room) {
      dialog = {
        open: true,
        head: 'Invalid',
        body: "All Fields are mandatory",
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
      flag = false;
    }

    if (!flag) {
      this.setState({
        dialog: dialog
      })
    }
    return flag;
  }

  render() {
    return (
      <Box header={this.props.details && this.props.details._id ? 'Edit Wifi' : 'New Wifi'}>
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        <div className="col-sm-12">
          <form className="smart-form " onSubmit={this.createTelephoneNumber.bind(this)}>
            <fieldset>
            <section>
                  <Select
                  id="days"
                  onBlurResetsInput={false}
                  onSelectResetsInput={false}
                  autoFocus
                  options={this.state.all_rooms}
                  searchable={true}
                  placeholder="Select Room"
                  value={this.state.room}
                  onChange={(newValue)=>{
                    console.log(newValue);
                    if(newValue){
                      this.setState({
                        room: newValue.value,
                        rooms: [newValue.value]
                      })
                    } else {
                        this.setState({
                            room: null,
                            rooms: null
                          })
                    }
                  }}
                  />
                </section>
              <section>
                <TextField
                  floatingLabelText="Wifi SSID"
                  name="ssid"
                  className="w-100"
                  value={this.state.ssid}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>

              <section>
                <TextField
                  floatingLabelText="Wifi Password"
                  name="password"
                  className="w-100"
                  type="password"
                  value={this.state.password}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>

              
            </fieldset>

            <div className="mt-4vw align-right">
              <RaisedButton
                label="Save"
                primary
                type="submit"
              />

              <span className="space"></span>

              {
                this.props.details ?
                  <FlatButton
                    label="Cancel"
                    primary
                    onClick={this.props.unMountMe.bind(this, false)}
                    type="button"
                  /> 
                : null
              }
            </div>
          </form>

        </div>
      </Box>
    )
  }
}


// WEBPACK FOOTER //
// ./components/wifi/NewWifi.js